import type { JwtVerifiedCredential } from '@dynamic-labs/sdk-api-core';

import type { DynamicClient } from '../../../../client/types';
import { assertDefined } from '../../../../utils/assertDefined';
import { getChainFromVerifiedCredentialChain } from '../../../../utils/getChainFromVerifiedCredentialChain';
import type { HardwareWalletVendor } from '../../hardwareWallet/hardwareWallet.types';
import type { WalletAccount } from '../../walletAccount';
import { getWalletProviderKeyFromVerifiedCredential } from '../../walletProvider/walletProviderKeyMap/getWalletProviderKeyFromVerifiedCredential';
import { formatWalletAccountId } from '../formatWalletAccountId';

type ConvertVerifiedCredentialToWalletAccountParams = {
  verifiedCredential: JwtVerifiedCredential;
};

export const convertVerifiedCredentialToWalletAccount = (
  { verifiedCredential }: ConvertVerifiedCredentialToWalletAccountParams,
  client: DynamicClient
): WalletAccount => {
  assertDefined(
    verifiedCredential.address,
    'Missing address in verified credential'
  );
  assertDefined(
    verifiedCredential.chain,
    'Missing chain in verified credential'
  );

  const chain = getChainFromVerifiedCredentialChain(verifiedCredential.chain);

  const { walletProviderKey } = getWalletProviderKeyFromVerifiedCredential(
    {
      verifiedCredential,
    },
    client
  );

  const walletAccountId = formatWalletAccountId({
    address: verifiedCredential.address,
    chain,
    walletProviderKey,
  });

  return {
    address: verifiedCredential.address,
    addressesWithTypes: verifiedCredential.walletAdditionalAddresses,
    chain,
    hardwareWalletVendor: verifiedCredential.walletProperties?.hardwareWallet as
      | HardwareWalletVendor
      | undefined,
    id: walletAccountId,
    lastSelectedAt: verifiedCredential.lastSelectedAt ?? null,
    verifiedCredentialId: verifiedCredential.id,
    walletProviderKey,
  };
};
